
export const EDIT_STATE_LABEL = (state) => {
    let NBSP = '\u00a0'
    return (
        //<span dangerouslySetInnerHTML={{__html: `Статус${NBSP}мода: ${state}`}}></span>
        <span dangerouslySetInnerHTML={{__html: `Статус${NBSP}мода: `}}></span>
    )
}
